// src/components/PreviewModal.tsx
import React from 'react';
import PergolaViewer from './visualization/PergolaViewer.tsx';

interface PreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  dxfContent: string;
}

const PreviewModal: React.FC<PreviewModalProps> = ({ isOpen, onClose, dxfContent }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg w-4/5 h-4/5">
        <div className="p-4 flex justify-between items-center border-b">
          <h2 className="text-xl font-bold">DXF Preview</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>
        </div>
        <div className="h-full">
          <PergolaViewer initialDxfContent={dxfContent} />
        </div>
      </div>
    </div>
  );
};

export default PreviewModal;